import React from 'react';
import Alert from '@amzn/awsui-components-core/alert';
import Box from '@amzn/awsui-components-core/box';
import Spinner from '@amzn/awsui-components-core/spinner';
import StatusIndicator from '@amzn/awsui-components-core/status-indicator';
import KeyValuePairs from '@amzn/awsui-components-core/key-value-pairs';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import type { DatasetWizardState } from 'src/components/star-grid/datasets/hooks/useDatasetWizard';
import styles from 'src/components/star-grid/datasets/components/styles/DatasetWizard.module.scss';

const LAYOUT_TEXT = { flat: 'wizardS3Layout_flat', snapshot: 'wizardS3Layout_snapshot', partitioned: 'wizardS3Layout_partitioned' } as const;

export const WizardAccessStep: React.FC<{ state: DatasetWizardState; text: StarGridText }> = ({ state, text }) => (
  <div className={styles.body}>
    {state.accessChecking && (
      <Box>
        <Spinner /> {text('wizardAccessChecking')}
      </Box>
    )}
    {!state.accessChecking && state.access?.accessible === true && <StatusIndicator type="success">{text('wizardAccessGranted')}</StatusIndicator>}
    {!state.accessChecking && state.access?.source && (
      <KeyValuePairs
        columns={4}
        data-testid="wizard-access-source"
        items={[
          { label: text('wizardAccessBucket'), value: state.access.source.bucket },
          { label: text('wizardAccessRegion'), value: state.access.source.region },
          { label: text('wizardAccessFormat'), value: state.access.source.format },
          { label: text('wizardAccessRole'), value: state.access.source.role_arn || text('wizardAccessOwnRole') }
        ]}
      />
    )}
    {!state.accessChecking && state.access?.layout && (
      <Box color="text-body-secondary" data-testid="wizard-access-layout">
        {text(LAYOUT_TEXT[state.access.layout.kind])}
        {state.access.layout.partition_columns.length > 0 && `: ${state.access.layout.partition_columns.join(', ')}`}
      </Box>
    )}
    {!state.accessChecking && state.access?.accessible === false && (
      <Alert type="error" header={text('wizardAccessBlocked')} data-testid="wizard-access-blocked">
        <KeyValuePairs
          columns={1}
          items={[
            { label: text('wizardAccessReason'), value: state.access.reason ?? '—' },
            { label: text('wizardAccessAction'), value: state.access.action ?? '—' },
            { label: text('wizardAccessContact'), value: state.access.contact ?? '—' }
          ]}
        />
      </Alert>
    )}
  </div>
);
